import styled from 'styled-components';
import mediaQueries from 'syf-component-library/const/mediaQueries';
import { spacing } from 'syf-component-library/defaultTheme';
import { Card } from 'syf-component-library/ui/atoms';
import { Inset } from 'syf-component-library/ui/spacing';
import { colors } from '../../../../defaultTheme';
import { SelectWrapper } from '../../../../ui/molecules/PaymentModalStates/subcomponents';
export const MultiPaymentFlowWrapper = styled.div `
  padding: 0 48px ${spacing.large}px 48px;
  flex-grow: 1;

  @media (${mediaQueries.lessThanMedium}) {
    padding: 0 ${spacing.base}px ${spacing.large}px ${spacing.base}px;
  }
`;
export const MultiPaymentCard = styled(Card) `
  border-radius: ${spacing.base}px;
  background-color: #fafafa;
  padding: ${spacing.base}px 64px;
  width: 100%;
  overflow: visible;
  box-sizing: border-box;
  box-shadow: none;

  @media ${mediaQueries.lessThanMedium} {
    padding: ${spacing.base}px;
  }
`;
export const Divider = styled.div `
  width: 100%;
  height: 1px;
  background-color: ${colors.mediumGrey};
  margin: ${spacing.medium}px 0px ${spacing.large}px 0px;
`;
export const MultiPaymentSectionWrapper = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const TextCenterWrapper = styled.div `
  text-align: center;
`;
export const FullWidthSelectWrapper = styled(SelectWrapper) `
  width: 100%;
  padding-top: ${spacing.base}px;
`;
export const InterstitialWrapper = styled(Inset) `
  overflow-y: auto;
  background-color: white;
  padding-top: 152px;
  padding-bottom: 0px;
  padding-left: 0;
  padding-right: 0;
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 56px;
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 1;
  @media ${mediaQueries.lessThanMedium} {
    padding-top: 0px;
  }
`;
export const InterstitialContent = styled(Inset) `
  flex-grow: 1;
  padding-bottom: 0px;
  padding-left: 132px;
  padding-right: 132px;
  @media ${mediaQueries.lessThanMedium} {
    display: flex;
    justify-content: center;
    padding-left: ${spacing.base}px;
    padding-right: ${spacing.base}px;
  }
`;
